var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-center",staticStyle:{"height":"100%"}},[_c('vue-qrcode',{attrs:{"value":_vm.link,"options":{ width: 300 }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }